import React from "react";
import { Button } from "react-bootstrap";
import { IconPrint } from "../icons";
import "./printbutton.scss";

export const PrintButton = ({ onClick, mpngStyle }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.print();
    }
  };
  return (
    <div className="mpng-header-printbutton" data-testid="header-printbutton">
      <Button
        aria-label="Print"
        variant="outline-primary"
        onClick={handleClick}
        className={`mpng-printbutton-button ${mpngStyle ? "mpng-style" : ""}`}
        tabIndex={0}
      >
        <IconPrint />
      </Button>
    </div>
  );
};

export default PrintButton;
